var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafariVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.79 44.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.46 30.06a6.24 6.24 0 1 0 6.07 6.41v-.18h0a6.17 6.17 0 0 0-6.07-6.23m-33.46 0a6.24 6.24 0 1 0 6.08 6.41v-.18h0A6.19 6.19 0 0 0 19 30.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.51 22.69a2.33 2.33 0 0 0-2.19-2.42l-15.42-1-2.81-10.19A2.19 2.19 0 0 0 44 7.44H10.39a3.25 3.25 0 0 0-3.26 3.23h0v22.24h5.33a7.17 7.17 0 0 1 9.6-3.26l.12.06a7.34 7.34 0 0 1 3.16 3.2H46a7.14 7.14 0 0 1 9.55-3.28.8.8 0 0 1 .16.08 7.24 7.24 0 0 1 3.16 3.2h7.6zm-34.8 1.73h4.16M13.46 6V2.25M39.12 6V2.25M8.46 1.5h35.66m-39.33 33h6.92m14.66 0h19.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46 34.5h11.83v-8.83M8.12 19.31H49M28.25 7.56v11.5M3.89 13.5h3.23v13.87h0-3.23A2.39 2.39 0 0 1 1.5 25v-9.11a2.39 2.39 0 0 1 2.39-2.39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariVehicle);
export default __webpack_public_path__ + "static/media/safariVehicle.430c72d6a0d920eec1d24506bc44b58d.svg";
export { ForwardRef as ReactComponent };